import { AppThunk } from '../../../store/rootReducer';
import { getBaseProperties, track } from '../analytics.utils';
import {
  ADD_WAVE_TAG,
  CHANGE_WAVE_TAG,
  DELETE_WAVE_TAG,
} from '../analytics.constants';
import { TagEventType } from '../types/analytics.types';
import { Wave } from '../../wave/types/wave.type';
import {
  getAssociativeTags,
  getOptionalTags,
  getRequiredTags,
  getTagContainerFromTags,
} from '../../wave/utils/tags.utils';
import { selectedIdsSelector } from '../../wave/selectors/wave.selectors';

export const trackWaveTag =
  (
    wave: Wave,
    value: string,
    type: TagEventType,
    analyticsTrack = track,
  ): AppThunk =>
  (_, getState) => {
    const selectedWaveIds = selectedIdsSelector(getState());
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;
    const properties = {
      view,
      ecg_id: ecgId,
      user_id: userId,
      multiple: selectedWaveIds.length > 1,
    };

    if (type === 'primary') {
      const previousTags = getRequiredTags(wave.tags);
      const previousTagContainer = getTagContainerFromTags(
        wave.type,
        previousTags,
      );
      if (previousTagContainer === null) {
        return analyticsTrack({
          name: ADD_WAVE_TAG,
          properties: {
            ...properties,
            type,
            value,
          },
        });
      } else if (previousTagContainer.name === value) {
        return analyticsTrack({
          name: DELETE_WAVE_TAG,
          properties: {
            ...properties,
            type,
            value,
          },
        });
      } else {
        return analyticsTrack({
          name: CHANGE_WAVE_TAG,
          properties: {
            ...properties,
            type,
            new_value: value,
            old_value: previousTagContainer.name,
          },
        });
      }
    } else if (type === 'secondary') {
      const previousOptionalTags = getOptionalTags(wave.tags);
      const optionalPreviousTagContainer = getTagContainerFromTags(
        wave.type,
        previousOptionalTags,
      );
      if (optionalPreviousTagContainer === null) {
        return analyticsTrack({
          name: ADD_WAVE_TAG,
          properties: {
            ...properties,
            type,
            value,
          },
        });
      } else if (optionalPreviousTagContainer.name === value) {
        return analyticsTrack({
          name: DELETE_WAVE_TAG,
          properties: {
            ...properties,
            type,
            value,
          },
        });
      } else {
        return analyticsTrack({
          name: CHANGE_WAVE_TAG,
          properties: {
            ...properties,
            type,
            new_value: value,
            old_value: optionalPreviousTagContainer.name,
          },
        });
      }
    } else if (type === 'noise') {
      const previousAssociativeTags = getAssociativeTags(wave.tags);
      if (previousAssociativeTags.length === 0) {
        return analyticsTrack({
          name: ADD_WAVE_TAG,
          properties: {
            ...properties,
            type,
            value,
          },
        });
      } else {
        return analyticsTrack({
          name: DELETE_WAVE_TAG,
          properties: {
            ...properties,
            type,
            value,
          },
        });
      }
    } else {
      return analyticsTrack({
        name: ADD_WAVE_TAG,
        properties: {
          ...properties,
          value,
          type,
          multiple: false,
        },
      });
    }
  };
